import { Card, Form, Switch, Typography } from "antd"
import { type PropsWithChildren, type ReactNode } from "react"

import { cn } from "../../utils/cn.ts"
import { type DocumentFormData } from "./document.types.ts"

interface DocumentCardProps extends PropsWithChildren {
  title: ReactNode
  withToggle?: boolean
  name: keyof Omit<DocumentFormData, "visible_blocks">
}

export function DocumentCard({
  title,
  withToggle = true,
  name,
  children
}: DocumentCardProps) {
  const form = Form.useFormInstance<DocumentFormData>()
  const visibleBlocks = Form.useWatch("visible_blocks", form)
  const isVisible = visibleBlocks?.includes(name)

  const handleToggle = (checked: boolean) => {
    const currentVisible = form.getFieldValue("visible_blocks") || []

    if (checked) {
      form.setFieldValue("visible_blocks", [...currentVisible, name])
    } else {
      form.setFieldValue(
        "visible_blocks",
        currentVisible.filter((section: string) => section !== name)
      )
    }
  }

  return (
    <Card
      size={"small"}
      title={
        <div className={"py-2 flex  gap-3 items-center justify-between"}>
          <div
            className={cn("flex-1", withToggle && !isVisible && "opacity-50")}
          >
            {typeof title === "string" ? (
              <Typography.Title level={4}>{title}</Typography.Title>
            ) : (
              title
            )}
          </div>

          {withToggle && <Switch checked={isVisible} onChange={handleToggle} />}
        </div>
      }
    >
      <div
        className={
          withToggle && !isVisible ? "pointer-events-none opacity-50" : ""
        }
      >
        {children}
      </div>
    </Card>
  )
}
